import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import {
  DataMessageTypeEnum,
  TerraUIMessageDataPartName,
} from '@terra/shared-dto-chat-types';
import { z } from 'zod';
import { normalizeToolName } from './tool-config.helpers';

const END_TEST_TOOL_NAME = 'end-test';

const END_TOOL_NAMES = new Set([
  'end',
  'end-analysis',
  'end-blocked',
  'end-confirmed-vulnerability',
  'end-not-observed',
  'end-suspected-vulnerability',
  'end-test',
]);

const EndToolArgsSchema = z.object({
  conclusion: z.string().trim().min(1).optional(),
});

export function isEndToolName(toolName: string): boolean {
  return END_TOOL_NAMES.has(normalizeToolName(toolName));
}

export function endToolConclusion(args: unknown): string | undefined {
  const parsed = EndToolArgsSchema.safeParse(args);

  if (!parsed.success) {
    return undefined;
  }

  return parsed.data.conclusion;
}

export function lastEndToolPartRef(history: TerraUIMessage[]):
  | {
      messageIndex: number;
      partIndex: number;
    }
  | undefined {
  let last: { messageIndex: number; partIndex: number } | undefined;

  history.forEach((message, messageIndex) => {
    (message.parts ?? []).forEach((part, partIndex) => {
      if (part.type !== TerraUIMessageDataPartName) {
        return;
      }

      const data = part.data;

      if (
        data?.type === DataMessageTypeEnum.ToolCallComplete &&
        typeof data.toolName === 'string' &&
        isEndToolName(data.toolName)
      ) {
        last = { messageIndex, partIndex };
      }
    });
  });

  return last;
}

export function hasEndTestCall(history: TerraUIMessage[]): boolean {
  return history.some((message) =>
    (message.parts ?? []).some(
      (part) =>
        part.type === TerraUIMessageDataPartName &&
        part.data?.type === DataMessageTypeEnum.ToolCallComplete &&
        typeof part.data.toolName === 'string' &&
        normalizeToolName(part.data.toolName) === END_TEST_TOOL_NAME,
    ),
  );
}
